export default {
  packageVersion: process.env.VUE_APP_VERSION,
  language: null,
  languages: [
    {
      label: 'Português',
      key: 'pt-BR',
    },
    {
      label: 'English',
      key: 'en-US',
    },
    {
      label: 'Español',
      key: 'es-ES',
    },
  ],
  manageFontSizesClasses: [
    'manage-fonts_14px',
    'manage-fonts_16px',
    'manage-fonts_18px',
  ],
  currentFontSize: 'manage-fonts_14px',
  appTheme: 'light',
  /**
   * Configurações da aplicação.
   * @property {Number} allowedAccessAttempts
   * @property {Number} limitOfPhysicalChemicalParametersCustomizations
   * @property {Boolean} offLineMode
   * @property {Boolean} blockUserByAccessAttempts
   * @property {String} hotjarInjectionClass
   * @property {Number} autoRefreshInterval Intervalo de atualização automatica em telas
   * de alarmes.
   */
  appConfiguration: null,
  errorGettingApplicationData: null,
  isPrinting: false,
  apiUnreachable: false,
};
